export default __webpack_public_path__ + "media/images/dashboard_icons/wallet-95e8921dbd2468a7483e3d719ebb07b0.svg";